/*
 * @Author: libo 
 * @Date: 2020-11-20 15:16:43 
 * @Last Modified by: mayanxia
 * @Last Modified time: 2022-05-19 10:55:13
 */

<!-- 抄表异常处理查询 -->
<template>
<a-row :gutter="10">
  <a-col :md="5" :sm="24">
    <a-card :bordered="false">
        <!-- 按钮操作区域 -->
        <div style="background: #fff;padding-left:16px;height: 100%; margin-top: 5px">
          <a-alert type="info" :showIcon="true">
            <div slot="message">
              {{ $t('当前选择：') }}<span v-if="this.currSelected.title">{{ getCurrSelectedTitle() }}</span>
              <a v-if="this.currSelected.title" style="margin-left: 10px" @click="unselect">{{ $t('取消选择') }}</a>
            </div>
          </a-alert>
          <a-input-search v-model="searchAreaValue" style="width:100%;margin-top: 10px" allowClear :placeholder="$t('请输入区域名称')"/>
          <!-- 树-->
          <a-col :md="24" :sm="24">
            <template>
              <a-spin tip="Loading..." :spinning="areaLoading">
                <!--
                <span style="user-select: none">
                  <a-tree
                    class="my-area-select-tree"
                    @select="onSelect"     
                    :selectedKeys="selectedKeys"
                    :treeData="areaTree"
                    :checkStrictly="checkStrictly"
                    :expandedKeys="iExpandedKeys"
                    :autoExpandParent="autoExpandParent"
                    @expand="onExpand">
                    <template slot="title" slot-scope="{title}">
                      <span v-if="title.indexOf(searchAreaValue) > -1">
                        {{title.substr(0, title.indexOf(searchAreaValue))}}
                      <span style="color: #32CD32">{{searchAreaValue}}</span>
                        {{title.substr(title.indexOf(searchAreaValue) + searchAreaValue.length)}}
                      </span>
                      <span v-else>{{title}}</span>
                    </template>
                  </a-tree>
                </span>
                -->
                <el-tree
                  class="filter-tree"
                  :data="areaTree"
                  :props="defaultProps"
                  :expand-on-click-node="false"
                  :filter-node-method="filterNode"
                  :check-on-click-node="true"
                  :check-strictly="checkStrictly"
                  :highlight-current="true"
                  node-key="id"
                  :current-node-key="currentNodeKey"
                  :default-expanded-keys="iExpandedKeys"
                  @node-click="nodeClick"
                  ref="areaTree">
                </el-tree>
              </a-spin>
            </template>
          </a-col>
        </div>
    </a-card>
  </a-col>
  <a-col :md="19" :sm="24">
    <a-card :bordered="false">
      <!-- 查询区域 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline" @keyup.enter.native="searchQuery">
          <a-row :gutter="24">
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item :label="$t('处理状态')">
                <a-select v-model="queryParam.top1" :placeholder="$t('请选择处理状态')">
                  <a-select-option value="0">
                    {{ $t('全部') }}
                  </a-select-option>
                  <a-select-option value="1">
                    {{ $t('处理中') }}
                  </a-select-option>
                  <a-select-option value="2">
                    {{ $t('已处理') }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item :label="$t('故障类型')">
                <a-select v-model="queryParam.top2" :placeholder="$t('请选择故障类型')">
                  <a-select-option value="0">
                    {{ $t('全部') }}
                  </a-select-option>
                  <a-select-option value="1">
                    {{ $t('阀门损坏') }}
                  </a-select-option>
                  <a-select-option value="2">
                    {{ $t('磁干扰') }}
                  </a-select-option>
                  <a-select-option value="3">
                    {{ $t('电池欠压') }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <template v-if="toggleSearchStatus">
              <a-col :xl="6" :lg="7" :md="8" :sm="24">
                <a-form-item :label="$t('表编号')">
                  <a-input :placeholder="$t('请输入表编号')" v-model="queryParam.meterId"></a-input>
                </a-form-item>
              </a-col>
              <a-col :xl="6" :lg="7" :md="8" :sm="24">
                <a-form-item :label="$t('用户姓名')">
                  <a-input :placeholder="$t('请输入用户姓名')" v-model="queryParam.userName"></a-input>
                </a-form-item>
              </a-col>
              <a-col :xl="6" :lg="7" :md="8" :sm="24">
                <a-form-item :label="$t('用户编号')">
                  <a-input :placeholder="$t('请输入用户编号')" v-model="queryParam.userId"></a-input>
                </a-form-item>
              </a-col>
              <a-col :xl="6" :lg="7" :md="8" :sm="24">
                <a-form-item :label="$t('用户地址')">
                  <a-input v-model="queryParam.userState" :placeholder="$t('请选择用户地址')"  style="width:100%"></a-input>
                </a-form-item>
              </a-col>
            </template>
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
                <a-button type="primary" @click="searchQuery" icon="search">{{ $t('查询') }}</a-button>
                <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{ $t('重置') }}</a-button>
                <a @click="handleToggleSearch" style="margin-left: 8px">
                  {{ toggleSearchStatus ? $t('收起') : $t('展开') }}
                  <a-icon :type="toggleSearchStatus ? 'up' : 'down'"/>
                </a>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作按钮区域 -->
      <div class="table-operator">
        <a-dropdown v-if="selectedRowKeys.length > 0">
          <a-menu slot="overlay">
            <a-menu-item key="1" @click="batchDel"><a-icon type="delete"/>{{ $t('删除') }}</a-menu-item>
          </a-menu>
          <a-button style="margin-left: 8px"> {{ $t('批量操作') }} <a-icon type="down" /></a-button>
        </a-dropdown>
      </div>
      <!-- table区域-begin -->
      <div>
        <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
          <i class="anticon anticon-info-circle ant-alert-icon"></i> {{ $t('已选择 {count} 项', { count: selectedRowKeys.length }) }}
          <a style="margin-left: 24px" @click="onClearSelected">{{ $t('清空') }}</a>
        </div>
        <a-table
          ref="table"
          size="middle"
          :scroll="{x:true}"
          bordered
          rowKey="id"
          :columns="columns"
          :dataSource="dataSource"
          :pagination="ipagination"
          :loading="loading"
          :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
          class="j-table-force-nowrap"
          @change="handleTableChange">
          <template slot="htmlSlot" slot-scope="text">
            <div v-html="text"></div>
          </template>
          <template slot="imgSlot" slot-scope="text">
            <span v-if="!text" style="font-size: 12px;font-style: italic;">{{ $t('无图片') }}</span>
            <img v-else :src="getImgView(text)" height="25px" alt="" style="max-width:80px;font-size: 12px;font-style: italic;"/>
          </template>
          <template slot="fileSlot" slot-scope="text">
            <span v-if="!text" style="font-size: 12px;font-style: italic;">{{ $t('无文件') }}</span>
            <a-button
              v-else
              :ghost="true"
              type="primary"
              icon="download"
              size="small"
              @click="downloadFile(text)">
              {{ $t('下载') }}
            </a-button>
          </template>
          <span slot="action" slot-scope="text, record">
            <a @click="readingAbnormalDispose(record)">{{ $t('处理') }}</a>
          </span>
        </a-table>
      </div>
      <meter-readingAbnormalDispose-modal ref="readingAbnormalDisposeModal" @ok="modalFormOk"></meter-readingAbnormalDispose-modal>
    </a-card>
  </a-col>
</a-row>
</template>

<script>
  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import {AreaChoosetMixin} from '@/mixins/AreaChooseMixin'
  import MeterReadingAbnormalDisposeModal from './modules/MeterReadingAbnormalDisposeModal'
  export default {
    name: 'MeterReadingAbnormalDisposeList',
    mixins:[JeecgListMixin, mixinDevice,AreaChoosetMixin],
    components: {
      MeterReadingAbnormalDisposeModal,
    },
    data () {
      return {
        data :[],
        item:{
        id:'',
        userMeterStartNum:'',
        userName:'',
        userId:''
        },
        visible: false,
        currSelected: {},
        dropTrigger: '',
        selectedKeys: [],
        areaTree: [],
        checkStrictly: true,
        iExpandedKeys: [],
        autoExpandParent: true,
        description: 'meter_userinfo管理页面',
        url: {
          list: "/jeecg-charge/meter/meterUserinfo/list",
          delete: "/jeecg-charge/meter/meterUserinfo/delete",
          deleteBatch: "/jeecg-charge/meter/meterUserinfo/deleteBatch",
          exportXlsUrl: "/jeecg-charge/meter/meterUserinfo/exportXls",
          importExcelUrl: "jeecg-charge/meter/meterUserinfo/importExcel",
        },
        dictOptions:{},
      }
    },
    created() {
    },
    computed: {
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
      // i18n：表头使用 computed 以响应语言切换
      columns() {
        return [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender: (t,r,index) => {
              return parseInt(index)+1;
            }
          },
          {
            title: this.$t('表编号'),
            align:"center",
            dataIndex: 'meterId'
          },
          {
            title: this.$t('用户编号'),
            align:"center",
            dataIndex: 'userId'
          },
          {
            title: this.$t('用户姓名'),
            align:"center",
            dataIndex: 'userName'
          },
          {
            title: this.$t('用户手机号'),
            align:"center",
            dataIndex: 'userPhone'
          },
          {
            title: this.$t('用户地址'),
            align:"center",
            dataIndex: 'userAddr'
          },
          {
            title: this.$t('表安装地址'),
            align:"center",
            dataIndex: 'userMeterAddr'
          },
          {
            title: this.$t('身份证号'),
            align:"center",
            dataIndex: 'userIdNumber'
          },
          {
            title: this.$t('区域名称'),
            align:"center",
            dataIndex: 'userAreaName'
          },
          {
            title: this.$t('创建时间'),
            align:"center",
            dataIndex: 'createTime'
          },
          {
            title: this.$t('创建人'),
            align:"center",
            dataIndex: 'createBy'
          },
          {
            title: this.$t('操作'),
            dataIndex: 'action',
            align:"center",
            fixed:"right",
            width:100,
            scopedSlots: { customRender: 'action' }
          }
        ]
      },
    },
    methods: {
      readingAbnormalDispose(record) {   //处理异常界面点击跳转
        this.$refs.readingAbnormalDisposeModal.edit(record)
        this.$refs.readingAbnormalDisposeModal.title = this.$t('处理异常')
      }
    }
  }
</script>
<style scoped>
  .background{
    background-color:rgb(238,238,238)
  }
  .my-area-select-tree /deep/ li .ant-tree-node-content-wrapper{
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
    white-space: nowrap;
  }
</style>